import Box from '@mui/material/Box'
import styled from '@mui/material/styles/styled'

export const Dot = styled(Box, {
  name: 'Dot',
  slot: 'Root',
  skipSx: true,
})`
  height: 12px;
  width: 12px;
  background-color: #19305a;
  border-radius: 50%;
  display: inline-block;
`
